import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
  routes: [
    {
      path: '/',
      name: 'home',
      component: () => import('@/views/Home.vue'),
    },

    // Catalogs
    // =====================================================================
    {
      path: '/catalogo/categorias',
      name: 'catalogs-categories',
      component: () => import('@/views/catalogs/categories/Categories.vue'),
      meta: {
        pageTitle: 'Categorías',
      },
    },
    {
      path: '/catalogo/colores',
      name: 'catalogs-colors',
      component: () => import('@/views/catalogs/colors/Colors.vue'),
      meta: {
        pageTitle: 'Colores',
      },
    },
    {
      path: '/catalogo/tallas',
      name: 'catalogs-sizes',
      component: () => import('@/views/catalogs/sizes/Sizes.vue'),
      meta: {
        pageTitle: 'Tallas',
      },
    },
    {
      path: '/catalogo/productos',
      name: 'catalogs-products',
      component: () => import('@/views/catalogs/products/Products.vue'),
      meta: {
        pageTitle: 'Productos',
      },
    },
    {
      path: '/catalogo/inventario',
      name: 'catalogs-inventory',
      component: () => import('@/views/catalogs/inventory/InventoryList.vue'),
      meta: {
        pageTitle: 'Inventario',
      },
    },
    {
      path: '/catalogo/listas-precios/:id?',
      name: 'catalogs-price-lists',
      component: () => import('@/views/catalogs/price-lists/PriceLists.vue'),
      meta: {
        pageTitle: 'Listas de Precios',
      },
      props: true,
    },

    // Contacts
    // =====================================================================
    {
      path: '/contactos/clientes',
      name: 'contacts-customers',
      component: () => import('@/views/contacts/customers/Customers.vue'),
      meta: {
        pageTitle: 'Clientes',
      },
    },
    {
      path: '/contactos/rutas',
      name: 'contacts-customer-routes',
      component: () => import('@/views/contacts/customerRoutes/CustomerRoutes.vue'),
      meta: {
        pageTitle: 'Rutas',
      },
    },

    // sales
    // =====================================================================
    {
      path: '/ventas/cotizaciones/:id?',
      name: 'sales-customer-quotes',
      component: () => import('@/views/sales/customerQuotes/CustomerQuotes.vue'),
      meta: {
        pageTitle: 'Cotizaciones',
      },
      props: true,
    },
    {
      path: '/ventas/pedidos/:id?',
      name: 'sales-customer-orders',
      component: () => import('@/views/sales/customerOrders/CustomerOrders.vue'),
      meta: {
        pageTitle: 'Pedidos',
      },
    },
    {
      path: '/ventas/venta-caida',
      name: 'sales-lost-sales',
      component: () => import('@/views/sales/lostSales/LostSalesList.vue'),
      meta: {
        pageTitle: 'Venta Caída',
      },
    },

    // Asistente IA
    // =====================================================================
    {
      path: '/asistente',
      name: 'chat-assistant',
      component: () => import('@/views/chat/ChatAssistant.vue'),
      meta: {},
    },

    // System
    // =====================================================================
    {
      path: '/login',
      name: 'login',
      component: () => import('@/views/Login.vue'),
      meta: {
        layout: 'full',
      },
    },
    {
      path: '/forgot-password',
      name: 'forgot-password',
      component: () => import('@/views/settings/access/restore/ForgotPassword.vue'),
      meta: {
        layout: 'full',
      },
    },
    {
      path: '/reset-password',
      name: 'reset-password',
      component: () => import('@/views/settings/access/restore/ResetPassword.vue'),
      meta: {
        layout: 'full',
      },
    },
    {
      path: '/sistema/usuarios',
      name: 'users',
      component: () => import('@/views/system/users/Users.vue'),
      meta: {
        pageTitle: 'Usuarios',
      },
    },
    {
      path: '/sistema/estadisticas-chat',
      name: 'system-chat-stats',
      component: () => import('@/views/system/chatStats/ChatStats.vue'),
      meta: {
        pageTitle: 'Estadísticas IA',
      },
    },
    {
      path: '/sistema/prompt-ia',
      name: 'system-chat-prompt',
      component: () => import('@/views/system/chatPrompt/ChatPromptAdmin.vue'),
      meta: {
        pageTitle: 'Prompt IA',
      },
    },
    /* {
      path: '/sistema/actualizaciones',
      name: 'updates',
      component: () => import('@/views/system/updates/Updates.vue'),
      meta: {
        pageTitle: 'Actualizaciones',
        breadcrumb: [
          {
            text: 'Sistema',
            link: false,
          },
          {
            text: 'Actualizaciones',
            active: true,
          },
        ],
      },
    }, */

    // Pages
    // =====================================================================
    {
      path: '/error-404',
      name: 'error-404',
      component: () => import('@/views/error/Error404.vue'),
      meta: {
        layout: 'full',
      },
    },
    {
      path: '*',
      redirect: 'error-404',
    },
  ],
})

// ? For splash screen
// Remove afterEach hook if you are not using splash screen
router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg')
  if (appLoading) {
    appLoading.style.display = 'none'
  }
})

export default router
